import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const taxgroupApi = createApi({
	reducerPath: "taxgroupApi",
	baseQuery: btBaseQuery,
	tagTypes: ["TaxGroup"],

	endpoints: (builder) => ({
		getTaxGroups: builder.query<bt_mtaxgroup[], void>({
			query: () => `taxgroup/`,
			providesTags: ["TaxGroup"],
		}),
		getTaxGroupById: builder.query<bt_mtaxgroup, string>({
			query: (id) => `taxgroup/byid/${id}`,
			providesTags: ["TaxGroup"],
		}),
		insertTaxGroup: builder.mutation({
			query: (taxgroup) => ({
				url: `/taxgroup/`,
				method: "POST",
				body: taxgroup,
			}),
			invalidatesTags: ["TaxGroup"],
		}),
		updateTaxGroup: builder.mutation({
			query: (taxgroup) => ({
				url: `/taxgroup/`,
				method: "PUT",
				body: taxgroup,
			}),
			invalidatesTags: ["TaxGroup"],
		}),
		deleteTaxGroup: builder.mutation({
			query: (taxgroup) => ({
				url: `/taxgroup/${taxgroup.tg_id}`,
				method: "DELETE",
				body: taxgroup,
			}),
			invalidatesTags: ["TaxGroup"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetTaxGroupsQuery,
	useGetTaxGroupByIdQuery,
	useInsertTaxGroupMutation,
	useUpdateTaxGroupMutation,
	useDeleteTaxGroupMutation,
} = taxgroupApi;
